<template>
    <div class="loading-spinner" :class="size && `size_${size}`">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Size } from '../Loading.interfaces';

    export default defineComponent({
        name: 'Spinner',
        components: {},
        props: {
            size: {
                type: String as PropType<Size>,
                default: 'm',
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Spinner.scss';
</style>
